//文字コードはutf-8

// ハンバーガーメニュー
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initHamburgerMenu() {
  const hamburgerBtn = document.querySelector('.jsHamburgerMenuBtn');
  const headerInner = document.querySelector('.jsHamburgerMenuTarget');
  const mq = window.matchMedia(MEDIA_QUERIES.smartphone);

  if (!hamburgerBtn || !headerInner) return;

  // ハンバーガーボタンのクリックイベント
  hamburgerBtn.addEventListener('click', function() {
    const isExpanded = hamburgerBtn.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      // メニューを閉じる
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      hamburgerBtn.setAttribute('aria-label', 'メニューを開く');
      headerInner.classList.remove('is-open');
      document.body.classList.remove('scrollLock');
    } else {
      // メニューを開く
      hamburgerBtn.setAttribute('aria-expanded', 'true');
      hamburgerBtn.setAttribute('aria-label', 'メニューを閉じる');
      headerInner.classList.add('is-open');
      document.body.classList.add('scrollLock');
    }
  });

  // メディアクエリの変化を監視
  const mqHandler = (e) => {
    if (!e.matches) {
      // PC表示になった時、メニューをリセット
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      hamburgerBtn.setAttribute('aria-label', 'メニューを開く');
      headerInner.classList.remove('is-open');
      document.body.classList.remove('scrollLock');
    }
  };

  // メディアクエリ変化のリスナーを追加
  if (mq.addEventListener) {
    mq.addEventListener('change', mqHandler);
  } else {
    mq.addListener(mqHandler);
  }
}
